import { type IConversation } from 'src/api/landlord-messages-api';

export const saveConversationsToLocalStorage = (conversations: IConversation[]) => {
    localStorage.setItem('conversations', JSON.stringify(conversations));
};

export const getConversationsFromLocalStorage = () => {
    const conversationsJSON = localStorage.getItem('conversations');
    return JSON.parse(conversationsJSON || '[]') as IConversation[];
};